import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '8px 0',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  paginationText: {
    color: theme.palette.text.secondary,
    fontSize: '14px',
    fontWeight: 400,
  },
  paginationNumbers: {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  pageSizeSelect: {
    minWidth: '70px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '4px',
    },
  },
  select: {
    fontSize: '14px',
    '& .MuiSelect-select': {
      padding: '8px 32px 8px 12px',
    },
  },
  pagination: {
    '& .MuiPaginationItem-root': {
      borderRadius: '4px',
      border: '1px solid #dde1df',
      boxShadow: '0px 2px 2px 0px rgba(9, 15, 13, 0.05)',
      minHeight: '32px',
    },
  },

  paginationButton: {
    // border: '1px solid #dde1df',
    // boxShadow: '0px -3px 2px 0px rgba(9, 15, 13, 0.05)',
    display: 'flex',
    fontSize: '14px',
    alignItems: 'center',
    // padding: '4px 14px',
    gap: '4px',
    // borderRadius: '4px',
    '& svg': {
      width: '24px',
      height: '24px',
      '& path': {
        stroke: theme.palette.mode === Mode.Dark ? theme.palette.common.white : undefined,
      },
    },
  },
  paginationArrow: {
    transform: 'rotate(180deg)',
  },
}));

export default useStyles;
